export default __webpack_public_path__ + "static/B0275-9f73aa7561f6ff48183a43b18fee968a.png";